"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var login_box_bg_svg_1 = __importDefault(require("@/assets/img/login-box-bg.svg"));
var _hoisted_1 = {
    key: 0,
    class: "app-layout"
};
var _hoisted_2 = { key: 0 };
var _hoisted_3 = {
    key: 1,
    class: "mobile"
};
var _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("img", {
    src: login_box_bg_svg_1.default,
    alt: ""
}, null, -1);
var _hoisted_5 = /*#__PURE__*/ (0, vue_2.createElementVNode)("h3", null, "吟一", -1);
var _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("p", null, "当前访问地址为PC端，手机端访问方式", -1);
var _hoisted_7 = /*#__PURE__*/ (0, vue_2.createElementVNode)("p", null, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("a", { href: "https://www.chensc.work/mobile/" }, " https://www.chensc.work/mobile/ ")
], -1);
var _hoisted_8 = [
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7
];
var vue_3 = require("vue");
var element_plus_1 = require("element-plus");
var zh_cn_mjs_1 = __importDefault(require("element-plus/dist/locale/zh-cn.mjs"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'App',
    setup: function (__props) {
        var routerAlive = (0, vue_3.ref)(true);
        var userAgent = navigator.userAgent;
        var isPC = (0, vue_3.ref)(true);
        // 判断是否为手机设备
        if (/(Android|iPhone|iPad|iPod|Mobile)/.test(userAgent)) {
            element_plus_1.ElNotification.closeAll();
            isPC.value = false;
        }
        var isDevToolsOpen = function () {
            var threshold = 160;
            return window.outerWidth - window.innerWidth > threshold || window.outerHeight - window.innerHeight > threshold;
        };
        var checkDevTools = function () {
            if (isDevToolsOpen()) {
                localStorage.clear();
                alert("请关闭开发者工具");
                window.location.href = 'https://www.baidu.com';
            }
            var onResize = function () {
                if (isDevToolsOpen()) {
                    localStorage.clear();
                    alert("请关闭开发者工具");
                    window.location.href = 'https://www.baidu.com';
                }
            };
            window.addEventListener("resize", onResize);
        };
        checkDevTools();
        (0, vue_3.provide)("reload", routerAlive);
        return function (_ctx, _cache) {
            var _component_router_view = (0, vue_2.resolveComponent)("router-view");
            var _component_el_config_provider = (0, vue_2.resolveComponent)("el-config-provider");
            return (routerAlive.value)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    ((0, vue_2.unref)(isPC))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                            (0, vue_2.createVNode)(_component_el_config_provider, { locale: (0, vue_2.unref)(zh_cn_mjs_1.default) }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createVNode)(_component_router_view)
                                ]; }),
                                _: 1
                            }, 8, ["locale"])
                        ]))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, _hoisted_8))
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
